// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1W9ww","footer":"Form_footer__1_tCt"};